<template>
  <div class="wrap">
    <HeroCarousel />

    <div class="detail">
      <div class="detail-shell">
    
  
        <div class="detail-top">
          <div
            class="detail-gallery"
            :key="'gallery-' + ($route.params.id || '0')"
          >
            <div
              ref="mainSwiperEl"
              class="swiper detail-main-swiper"
              aria-roledescription="carousel"
            >
              <div class="swiper-wrapper">
                <div
                  v-for="(img, idx) in galleryImages"
                  :key="idx"
                  class="swiper-slide"
                >
                  <div class="detail-main-slide">
                    <img
                      :src="img"
                      :alt="'Product image ' + (idx + 1)"
                      class="detail-main-img"
                    >
                  </div>
                </div>
              </div>
              <div class="swiper-button-prev detail-gallery-prev" :aria-label="$t('detail.ariaPrev')" />
              <div class="swiper-button-next detail-gallery-next" :aria-label="$t('detail.ariaNext')" />
            </div>
            <div
              ref="thumbSwiperEl"
              class="swiper detail-thumb-swiper"
              :aria-label="$t('detail.thumbCarousel')"
            >
              <div class="swiper-wrapper">
                <div
                  v-for="(img, idx) in galleryImages"
                  :key="'t-' + idx"
                  class="swiper-slide"
                >
                  <div class="detail-thumb-slide">
                    <img :src="img" alt="">
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="detail-info">
            <h1 class="detail-title" v-html="detailPayload.name_html"></h1>

            <section class="detail-block">
              <h2 class="detail-block-title" v-if="$route.params.id !== '2'">{{ $t('detail.featuresTitle') }}</h2>
              <p class="detail-features-text" v-html="detailPayload.features_html"></p>
            </section>

            <section class="detail-block">
              <table  class="detail-spec-table">
                <tbody>
                  <tr v-for="(s, i) in detailSpecs" :key="i">
                    <th :style="{ lineHeight: returnThLineHeight() }" scope="row">{{ s.label }}</th>
                    <td :style="{ lineHeight: returnTdLineHeight() }">{{ s.value }}</td>
                  </tr>
                </tbody>
              </table>
              <div class="detail-spec-rule" aria-hidden="true" />
            </section>

         
        
          
          </div>
        </div>

        
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper/swiper-bundle.mjs'
import 'swiper/swiper-bundle.css'
import HeroCarousel from '@/components/HeroCarousel.vue'





/** 本页写死展示数据（不依赖路由 / products.js） */
const PAGE_PRODUCT = {
 
  colorLabel: 'White',

}

export default {
  name: 'Detail',
  components: {
    HeroCarousel,
  },
  data() {
    return {
      product: PAGE_PRODUCT,
      activeImageIndex: 0,
    }
  },
  computed: {
    /** 第 0 张为顶部默认主图，其余为下方缩略图 */
    galleryImages() {
      if (this.$route.params.id === '1') {
        return [
          require('@/assets/b18-1.jpg'),
          require('@/assets/b18-2.jpg'),
          require('@/assets/b18-3.jpg'),
          require('@/assets/b18-4.jpg'),
          require('@/assets/b18-5.jpg'),
        ]
      }
      if (this.$route.params.id === '2') {
        return [
          require('@/assets/s9-1.jpg'),
          require('@/assets/s9-2.jpg'),
          require('@/assets/s9-3.jpg'),
          require('@/assets/s9-4.jpg'),
          require('@/assets/s9-5.jpg'),
        ]
      }
      if (this.$route.params.id === '3') {
        return [
          require('@/assets/H15-1.jpg'),
          require('@/assets/H15-2.jpg'),
          require('@/assets/H15-3.jpg'),
          require('@/assets/H15-4.jpg'),
          require('@/assets/H15-5.jpg'),
        ]
      }
      if (this.$route.params.id === '4') {
        return [
          require('@/assets/bx09-1.jpg'),
          require('@/assets/bx09-2.jpg'),
          require('@/assets/bx09-3.jpg'),
          require('@/assets/bx09-4.jpg'),
          require('@/assets/bx09-5.jpg'),
        ]
      }
      return []
    },
    detailPayload() {
      const id = this.$route.params.id
      const pid = `p${id}`
      const fb =
        (this.$i18n.messages.en &&
          this.$i18n.messages.en.detail &&
          this.$i18n.messages.en.detail[pid]) ||
        {}
      const loc =
        this.$i18n.messages[this.$i18n.locale] &&
        this.$i18n.messages[this.$i18n.locale].detail &&
        this.$i18n.messages[this.$i18n.locale].detail[pid]
      return loc ? { ...fb, ...loc } : fb
    },
    detailSpecs() {
      return this.detailPayload.specs || []
    },
  },
  watch: {
    '$route.params.id': {
      handler() {
        this.destroyDetailGallerySwipers()
        this.$nextTick(() => {
          this.initDetailGallerySwipers()
        })
      },
    },
  },

  mounted() {
    this.$nextTick(() => this.initDetailGallerySwipers())
  },
  beforeDestroy() {
    this.destroyDetailGallerySwipers()
  },
  methods: {
    returnThLineHeight() {
      if (this.$route.params.id === '1') {
        return '64px!important';
      } else if (this.$route.params.id === '2') {
        return '10px!important';
      } else if (this.$route.params.id === '3') {
        return '64px!important';
      } else if (this.$route.params.id === '4') {
        return '60px!important';
      }

    },
    returnTdLineHeight() {
      if (this.$route.params.id === '1') {
        return '42px!important';
      } else if (this.$route.params.id === '2') {
        return '45px!important';
      } else if (this.$route.params.id === '3') {
        return '50px!important';
      } else if (this.$route.params.id === '4') {
        return '42px';
      }

    },
    destroyDetailGallerySwipers() {
      if (this.mainSwiper) {
        try {
          this.mainSwiper.destroy(true, true)
        } catch (e) {
          /* ignore */
        }
        this.mainSwiper = null
      }
      if (this.thumbSwiper) {
        try {
          this.thumbSwiper.destroy(true, true)
        } catch (e) {
          /* ignore */
        }
        this.thumbSwiper = null
      }
    },
    initDetailGallerySwipers() {
      const mainEl = this.$refs.mainSwiperEl
      const thumbEl = this.$refs.thumbSwiperEl
      if (!mainEl || !thumbEl || !this.galleryImages.length) return

      this.thumbSwiper = new Swiper(thumbEl, {
        spaceBetween: 12,
        slidesPerView: 'auto',
        freeMode: true,
        watchSlidesProgress: true,
      })

      this.mainSwiper = new Swiper(mainEl, {
        speed: 450,
        spaceBetween: 0,
        slidesPerView: 1,
        navigation: {
          nextEl: mainEl.querySelector('.detail-gallery-next'),
          prevEl: mainEl.querySelector('.detail-gallery-prev'),
        },
        thumbs: {
          swiper: this.thumbSwiper,
          multipleActiveThumbs: false,
        },
      })
    },
    goContact() {
      this.$router.push({ name: 'home', hash: '#contact' }).catch(() => {})
    },
  },
}
</script>

<style scoped>
.wrap {
  min-height: 100vh;
}

.detail {
  padding: 95px 16px 48px;
  box-sizing: border-box;
  background: #ffffff;
}

.detail-shell {
  max-width: 1570px;
  margin: 0 auto;
  width: 100%;
  box-sizing: border-box;
  background:#F6F7FA;
}

.detail-back {
  margin-bottom: 20px;
}

.detail-top {
  padding: 63px 20px 71px 61px;
  display: flex;
  flex-wrap: wrap;
  gap: 40px 0px;
  align-items: flex-start;
  justify-content: space-around;
}

.detail-gallery {
  flex: 0 0 auto;
  max-width: 100%;
}

.detail-main-swiper {
  width: 800px;
  height: 800px;
  max-width: 100%;
  background: #fff;
  position: relative;
  box-sizing: border-box;
}

.detail-main-swiper ::v-deep .swiper-slide {
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  height: 100%;
}

.detail-main-slide {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.detail-main-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}

.detail-main-swiper ::v-deep .swiper-button-prev,
.detail-main-swiper ::v-deep .swiper-button-next {
  width: 48px;
  height: 48px;
  border-radius: 2px;
  background: rgba(80, 80, 80, 0.45);
  color: #fff;
  margin-top: 0;
  top: 50%;
  transform: translateY(-50%);
}

.detail-main-swiper ::v-deep .swiper-button-prev::after,
.detail-main-swiper ::v-deep .swiper-button-next::after {
  font-size: 22px;
  font-weight: 700;
}

.detail-main-swiper ::v-deep .swiper-button-prev:hover,
.detail-main-swiper ::v-deep .swiper-button-next:hover {
  background: rgba(60, 60, 60, 0.65);
  color: #0f62ea;
}

.detail-thumb-swiper {
  width: 800px;
  max-width: 100%;
  margin-top: 20px;
}

.detail-thumb-swiper ::v-deep .swiper-slide {
  width: 150px;
  height: 150px;
  box-sizing: border-box;
}

.detail-thumb-slide {
  width: 100%;
  height: 100%;
  border: 2px solid transparent;
  background: #fff;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.detail-thumb-slide img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  display: block;
}

.detail-thumb-swiper ::v-deep .swiper-slide-thumb-active .detail-thumb-slide {
  border-color:rgb(228, 230, 237);
  box-shadow: 0 2px 8px rgba(37, 99, 235, 0.25);
}

.detail-info {
  flex: 1;
  min-width: 280px;
  max-width: 640px;
}

.detail-title {
  margin: 0 0 17px;
  font-family: LINESeedJP_TTF, LINESeedJP_TTF;
  font-weight: bold;
  font-size: 52px;
  color: #282828;
  line-height: 57px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}

.detail-block {
  margin-bottom: 28px;
}

.detail-block-title {
  margin: 0 0 23px;
  font-family: LINESeedJP_TTF, LINESeedJP_TTF;
  font-weight: bold;
  font-size: 21px;
  color: #282828;
  line-height: 16px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}

.detail-features-text {
  margin: 0;
  font-family: LINESeedJP_TTF, LINESeedJP_TTF;
  font-weight: 400;
  font-size: 20px;
  color: #A1A1A1;
  line-height: 32px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}

.detail-spec-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
  border-top: 1px solid #E5E5E5;
}

.detail-spec-table th {
font-weight: 500;
font-size: 18px;
color: #A1A1A1;
line-height: 42px;
text-align: left;
font-style: normal;
text-transform: none;
}

.detail-spec-table td {
font-weight: 500;
font-size: 18px;
color: #282828;
line-height: 42px;
text-align: left;
font-style: normal;
text-transform: none;
}

.detail-spec-rule {
  height: 1px;
  background: linear-gradient(to right, #d0d0d0, #ededed);
  margin-top: 8px;
}

.detail-colors {
  margin-bottom: 32px;
}

.detail-color-swatch {
  width:100%;
  max-width:322px;
 object-fit: contain;
  height: 78px;
  border-radius: 8px;
  background:#E3E6EE;
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding: 8px;
  box-sizing: border-box;
}

.detail-color-inner {
  cursor: pointer;
  width: 47px;
  height: 47px;
  border-radius: 50%;
  background:#FFFFFF;
  border: 1px solid #ddd;
  display: block;
}

.detail-cta {
  display: inline-block;
  min-width: 200px;
  padding: 16px 40px;
  background: #2563eb;
  color: #fff;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0.08em;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  text-transform: uppercase;
  transition: background 0.2s ease;
}

.detail-cta:hover {
  background: #1d4ed8;
}

.detail-cta-wrap {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 90px;
}
.detail-cta {
  object-fit: contain;
  height: 65px;
  background: #0F62EA;
  border-radius: 33px 33px 33px 33px;
  font-family: LINESeedJP_TTF, LINESeedJP_TTF;
  font-weight: bold;
  font-size: 24px;
  color: #FFFFFF;
  line-height: 19px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}
.related {
  margin-top: 48px;
  padding-top: 32px;
  border-top: 1px solid #ddd;
}

.related-title {
  font-weight: 800;
  font-size: 18px;
  margin-bottom: 16px;
}

.related-card {
  height: 100%;
}

.related-img-wrap {
  height: 160px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.related-img {
  max-width: 100%;
  max-height: 150px;
  object-fit: contain;
}

.related-name {
  margin-top: 10px;
  font-weight: 700;
}

.related-footer {
  margin-top: 10px;
}

@media (max-width: 1200px) {
  .detail-top {
    flex-direction: column;
  }

  .detail-main-swiper {
    width: min(800px, 100%);
    height: auto;
    aspect-ratio: 1;
    max-height: 80vw;
  }

  .detail-thumb-swiper ::v-deep .swiper-slide {
    width: min(150px, 26vw);
    height: min(150px, 26vw);
  }

  .detail-info {
    max-width: none;
  }
}

@media (max-width: 640px) {
  .detail-thumb-swiper ::v-deep .swiper-slide {
    width: calc(50vw - 40px);
    height: calc(50vw - 40px);
    max-width: 150px;
    max-height: 150px;
  }
}
</style>
